export interface ICrimePoint {
    CrimePointID: number;
    NumCrimes: number;
    OBJECTID: number;
    Street: string;
}

export class CrimePoint implements ICrimePoint {
    public CrimePointID: number;
    public NumCrimes: number;
    public OBJECTID: number;
    public Street: string;
    constructor(
        crimeObject: any,
    ) {
        this.CrimePointID = crimeObject.CrimePointID;
        this.NumCrimes = crimeObject.NumCrimes;
        this.OBJECTID = crimeObject.OBJECTID;
        this.Street = crimeObject.Street;
    }
}
